/**
 * Lemich Wishlist Manager
 * - Persiste en localStorage bajo "lemich_wishlist"
 * - Dispara evento "wishlist:updated" para badges y contadores
 * - Maneja botones .wishlist-trigger
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'lemich_wishlist';
  const EVENT = 'wishlist:updated';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function setList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) {}
    document.dispatchEvent(new Event(EVENT));
    if (window.dispatchEvent) window.dispatchEvent(new Event(EVENT));
  }

  function has(productId) {
    return getList().some((item) => String(item.id) === String(productId));
  }

  function add(product) {
    const list = getList();
    if (has(product.id)) return false;
    list.push({
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: parseFloat(product.price) || 0,
      image: product.image,
      url: product.url,
      addedAt: Date.now()
    });
    setList(list);
    return true;
  }

  function remove(productId) {
    const list = getList().filter((item) => String(item.id) !== String(productId));
    setList(list);
  }

  function toggle(product) {
    if (has(product.id)) { remove(product.id); return false; }
    add(product); return true;
  }

  function clear() {
    setList([]);
  }

  function bindTriggers() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-trigger');
      if (!btn) return;
      e.preventDefault();
      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl
      };
      const isNowActive = toggle(product);
      btn.classList.toggle('is-active', isNowActive);
      btn.setAttribute('aria-pressed', isNowActive ? 'true' : 'false');
      // Toast feedback
      showToast(isNowActive ? 'Añadido a tu lista de deseos' : 'Eliminado de tu lista de deseos');
    });
  }

  function syncActiveStates() {
    const list = getList();
    document.querySelectorAll('.wishlist-trigger').forEach((btn) => {
      const id = btn.dataset.productId;
      const active = list.some((item) => String(item.id) === String(id));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function showToast(message) {
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const existing = document.querySelector('.lemich-toast');
    if (existing) existing.remove();
    const t = document.createElement('div');
    t.className = 'lemich-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.textContent = message;
    Object.assign(t.style, {
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'var(--color-dark)',
      color: 'var(--color-cream)',
      padding: '12px 20px',
      borderRadius: '4px',
      fontSize: '0.875rem',
      zIndex: 'var(--z-toast, 1500)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      transition: reduced ? 'none' : 'opacity 0.3s ease',
      opacity: reduced ? '1' : '0'
    });
    document.body.appendChild(t);
    if (!reduced) {
      requestAnimationFrame(() => (t.style.opacity = '1'));
    }
    setTimeout(() => {
      if (reduced) { t.remove(); return; }
      t.style.opacity = '0';
      setTimeout(() => t.remove(), 300);
    }, 2200);
  }

  // Exponer API global
  window.LemichWishlist = { getList, setList, add, remove, toggle, has, clear };

  function init() {
    bindTriggers();
    syncActiveStates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
